import { render } from "./QuoteProofreading.vue?vue&type=template&id=36d021dd&scoped=true"
import script from "./QuoteProofreading.vue?vue&type=script&lang=js"
export * from "./QuoteProofreading.vue?vue&type=script&lang=js"

import "./QuoteProofreading.vue?vue&type=style&index=0&id=36d021dd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-36d021dd"

export default script